import Button from '@mui/material/Button';
import React, { useState } from 'react';
import cc from 'classcat';
import AddIcon from '@mui/icons-material/Add';
import C from './GroupFormModal.css';
import GroupFormModal from './GroupFormModal';
import { Trans } from '@lingui/macro';

export default function NewGroupControl(p: { communityId: string }) {
  const [showingModal, setShowingModal] = useState(false);
  return (
    <>
      <Button
        className={cc([C.capsuleBtn, C.active])}
        startIcon={<AddIcon />}
        onClick={() => {
          setShowingModal(true);
        }}
      >
        <Trans>New Group</Trans>
      </Button>
      {showingModal && (
        <GroupFormModal
          communityId={p.communityId}
          onClose={() => {
            setShowingModal(false);
          }}
        />
      )}
    </>
  );
}
